import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../../../../axios-global';

import Button from 'grommet/components/Button';
import Notification from 'grommet/components/Notification';
import Spinning from 'grommet/components/icons/Spinning';
import classes from './AddEditTrainer.module.scss';
import withUser from '../../../../store/hoc/withUser';

import FormCreator from '../../../../components/UI/FormCreator/FormCreator';
import { checkValidity, returnErrorTextForField } from '../../../../shared/utility';

import * as actions from '../../../../store/actions/index';
import Columns from 'grommet/components/Columns';
import Box from 'grommet/components/Box';
import CheckBox from 'grommet/components/CheckBox';
import { isFullAccessAdminOrTrainer, returnGymsByAccess } from '../../../../shared/userFunctions';

const cloneDeep = require('lodash.clonedeep');

const mapStateToProps = (state) => {
  return {
    selectedGym: state.admin.selectedGym,
    locations: state.location.locations
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchTrainersList: (gymId) => dispatch(actions.fetchTrainersList(gymId))
  };
};

class TrainersAddEditTrainer extends Component {
  state = {
    formIsValid: false,
    formValidated: false,
    loading: false,
    error: null,
    fullAccess: false,
    selectedGyms: null,
    selectedGymsAreValid: null,
    userSelectedGyms: {},
    trainerForm: {
      title: {
        label: 'Title',
        type: 'select',
        options: ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr'],
        placeholder: 'Select title',
        value: 'Mr',
        validation: {
          required: true
        },
        valid: true,
        touched: false,
        errorText: null
      },
      name: {
        label: 'First name',
        type: 'text',
        placeholder: 'Enter first name',
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        errorText: null
      },
      last_name: {
        label: 'Last name',
        type: 'text',
        placeholder: 'Enter last name',
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        errorText: null
      },
      email: {
        label: 'E-mail',
        type: 'text',
        placeholder: 'Enter e-mail',
        value: '',
        validation: {
          required: true,
          isEmail: true
        },
        valid: false,
        touched: false,
        errorText: null
      },
      phone_number: {
        label: 'Phone number',
        type: 'text',
        placeholder: 'Enter telephone number',
        value: '',
        validation: {
          required: true,
          isUkTelephone: true
        },
        valid: false,
        touched: false,
        errorText: null
      },
      password: {
        label: 'Password',
        type: 'password',
        placeholder: 'Enter password',
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        errorText: null
      },
      confirmPassword: {
        label: 'Confirm password',
        type: 'password',
        placeholder: 'Confirm password',
        value: '',
        basePasswordValue: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        errorText: null
      }
    }
  };

  componentDidMount() {
    let gymsList = {};
    this.props.locations.forEach((elem) => {
      gymsList[elem._id] = false;
    });

    this.setState({
      selectedGyms: this.props.gymsList ? this.props.gymsList : gymsList
    });
    if (this.props.editTrainer) {
      const copiedForm = cloneDeep(this.state.trainerForm);
      delete copiedForm.password;
      delete copiedForm.confirmPassword;

      const selectedGyms =
        this.props.editTrainer['gymsFullAccess'] === undefined || this.props.editTrainer.gymsFullAccess
          ? this.setFullAccess(this.props.gymsList)
          : this.setSelectedGyms(this.props.editTrainer.gymId, this.props.gymsList);

      const fullAccess =
        this.props.editTrainer['gymsFullAccess'] === undefined || this.props.editTrainer.gymsFullAccess;
      this.setState(
        {
          trainerForm: copiedForm,
          selectedGyms,
          userSelectedGyms: this.props.gymsList,
          fullAccess
        },
        () => this.assignExisitingValues()
      );
    }
  }

  setSelectedGyms = (array, selectedGyms) => {
    array.forEach((elem) => {
      selectedGyms[elem] = true;
    });
    return selectedGyms;
  };

  assignExisitingValues = () => {
    const formNames = Object.keys(this.props.editTrainer);
    const previousValues = Object.values(this.props.editTrainer);
    const copiedForm = cloneDeep(this.state.trainerForm);

    formNames.forEach((element, index) => {
      if (copiedForm.hasOwnProperty(element) && copiedForm[element] !== undefined) {
        copiedForm[element] = {
          ...copiedForm[element],
          value: previousValues[index],
          valid: true,
          touched: true
        };
      }
    });

    this.setState({
      trainerForm: copiedForm
    });
  };

  valueChangedHandler = (newValue, identifier) => {
    const copiedForm = cloneDeep(this.state.trainerForm);

    if (identifier !== 'confirmPassword') {
      copiedForm[identifier] = {
        ...copiedForm[identifier],
        value: newValue,
        valid: checkValidity(newValue, this.state.trainerForm[identifier].validation),
        errorText: returnErrorTextForField(this.state.trainerForm[identifier].validation),
        touched: true
      };
      return this.setState({
        trainerForm: copiedForm
      });
    }

    // update for confirm password
    copiedForm[identifier] = {
      ...copiedForm[identifier],
      value: newValue,
      valid: checkValidity(newValue, this.state.trainerForm[identifier].validation),
      errorText: returnErrorTextForField(this.state.trainerForm[identifier].validation),
      touched: true,
      basePasswordValue: this.state.trainerForm.password.value
    };

    return this.setState({
      trainerForm: copiedForm
    });
  };

  checkFormValidity = () => {
    this.setState({ formValidated: true });
    const selectedGymsAreValid =
      Object.keys(this.state.selectedGyms).filter((k) => this.state.selectedGyms[k]).length > 0;

    let formIsValid;

    for (let input in this.state.trainerForm) {
      if (!this.state.trainerForm[input].valid) {
        const copiedForm = cloneDeep(this.state.trainerForm);
        copiedForm[input] = {
          ...copiedForm[input],
          valid: checkValidity(copiedForm[input].value, copiedForm[input].validation),
          errorText: returnErrorTextForField(copiedForm[input].validation),
          touched: true
        };

        if (this.props.editTrainer) {
          document.getElementsByClassName('ss-modal')[0].scrollTop = 0;
        } else {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
        formIsValid = false;

        return this.setState({
          formIsValid,
          trainerForm: copiedForm,
          selectedGymsAreValid
        });
      }
    }
    formIsValid = selectedGymsAreValid;
    this.setState({
      formIsValid,
      selectedGymsAreValid
    });

    if (selectedGymsAreValid && formIsValid) {
      if (this.props.editTrainer) {
        this.saveEditedTrainer();
      } else {
        this.trainersAddTrainer();
      }
    }
    return;
  };

  passErrorMessagesToForm = (error) => {
    if (error.response && error.response.data && error.response.data.errors) {
      const formNames = Object.keys(error.response.data.errors);
      const errorsMessages = Object.values(error.response.data.errors);
      const copiedForm = cloneDeep(this.state.trainerForm);

      formNames.forEach((element, index) => {
        if (this.state.trainerForm.hasOwnProperty(element) && this.state.trainerForm[element] !== undefined) {
          copiedForm[element] = {
            ...copiedForm[element],
            valid: false,
            errorText: errorsMessages[index].message,
            touched: true
          };
        }
      });

      this.setState({
        trainerForm: copiedForm
      });
    } else {
      // eslint-disable-next-line
      console.log(error.response);
    }
  };

  trainersAddTrainer = () => {
    this.setState({ loading: true });

    const trainerFormData = {
      role: 'trainer'
    };
    for (let input in this.state.trainerForm) {
      trainerFormData[input] = this.state.trainerForm[input].value;

      if (typeof trainerFormData[input] === 'string' && trainerFormData[input].toLowerCase() === 'yes') {
        trainerFormData[input] = true;
      }
      if (typeof trainerFormData[input] === 'string' && trainerFormData[input].toLowerCase() === 'no') {
        trainerFormData[input] = false;
      }
    }

    trainerFormData.gymsFullAccess = this.state.fullAccess;

    let selectedGyms = [];
    const gyms = this.state.selectedGyms;
    if (!this.state.fullAccess) {
      Object.keys(gyms).forEach(function (key) {
        if (gyms[key]) {
          selectedGyms.push(key);
        }
      });
    }

    trainerFormData.gymId = trainerFormData.gymsFullAccess ? [] : selectedGyms;

    axios
      .post(`/users/gym/${this.props.selectedGym._id}`, trainerFormData)
      .then(() => {
        this.setState({ loading: false });
        this.props.onFetchTrainersList(this.props.selectedGym._id);
        this.props.history.goBack();
      })
      .catch((error) => {
        this.passErrorMessagesToForm(error);

        this.setState({
          loading: false
        });
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      });
  };

  setFullAccess = (gyms) => {
    let selectedGyms = {};
    let gymsListNew = {};
    this.props.locations.forEach((elem) => {
      gymsListNew[elem._id] = true;
    });

    if (gyms) {
      Object.keys(gyms).forEach(function (key) {
        selectedGyms[key] = true;
      });
    }

    return gyms ? selectedGyms : gymsListNew;
  };

  saveEditedTrainer = () => {
    const trainerFormData = {};
    for (let input in this.state.trainerForm) {
      trainerFormData[input] = this.state.trainerForm[input].value;

      if (typeof trainerFormData[input] === 'string' && trainerFormData[input].toLowerCase() === 'yes') {
        trainerFormData[input] = true;
      }
      if (typeof trainerFormData[input] === 'string' && trainerFormData[input].toLowerCase() === 'no') {
        trainerFormData[input] = false;
      }
    }

    trainerFormData.gymsFullAccess = this.state.fullAccess;

    let selectedGyms = [];
    const gyms = this.state.selectedGyms;
    if (!this.state.fullAccess) {
      Object.keys(gyms).forEach(function (key) {
        if (gyms[key]) {
          selectedGyms.push(key);
        }
      });
    }

    trainerFormData.gymId = trainerFormData.gymsFullAccess ? [] : selectedGyms;

    axios
      .patch(`/users/${this.props.editTrainer._id}`, trainerFormData)
      .then(() => {
        this.setState({ loading: false });
        this.props.onFetchTrainersList(this.props.selectedGym._id);
        this.props.closeModal();
      })
      .catch((error) => {
        this.passErrorMessagesToForm(error);

        this.setState({
          loading: false
        });
      });
  };
  renderGymSelection = (data) => {
    const fullAccess = () => {
      if (this.state.fullAccess) {
        this.setState({
          fullAccess: false,
          selectedGyms: this.state.userSelectedGyms
        });
      } else {
        this.setState({
          fullAccess: true,
          selectedGyms: this.setFullAccess(this.props.gymsList)
        });
      }
    };

    const selectGym = (gymId) =>
      this.setState({
        selectedGyms: {
          ...this.state.selectedGyms,
          [gymId]: !this.state.selectedGyms[gymId]
        },
        userSelectedGyms: {
          ...this.state.selectedGyms,
          [gymId]: !this.state.selectedGyms[gymId]
        },
        fullAccess: false
      });

    return (
      <div
        className={classes.gymSelector}
        style={
          this.state.selectedGymsAreValid === null || this.state.selectedGymsAreValid
            ? {}
            : {
                background: '#fcc9c0',
                padding: '20px 0px 10px 40px',
                borderRadius: '20px'
              }
        }>
        <h4>Select gym access:</h4>

        {isFullAccessAdminOrTrainer(this.props.userData) && (
          <CheckBox
            label="Full access"
            onChange={fullAccess}
            className={classes.fullAccess}
            checked={this.state.fullAccess}
          />
        )}
        {data.map((gym) => (
          <CheckBox
            label={gym.name}
            onChange={() => selectGym(gym._id)}
            key={gym._id}
            checked={this.state.selectedGyms[gym._id]}
          />
        ))}
        {!this.state.selectedGymsAreValid && this.state.selectedGymsAreValid !== null && (
          <p style={{ color: 'red', fontWeight: 'bold' }}>Please select gym</p>
        )}
      </div>
    );
  };
  render() {
    let formWarning = null;
    if (!this.state.formIsValid && this.state.formValidated) {
      formWarning = (
        <Notification message="Form is not filled in correctly" status="warning" className="ss-top-notification" />
      );
    }

    let button = (
      <Button
        style={{ display: 'block', margin: '20px auto', width: '100%' }}
        label={this.props.editTrainer ? 'Save' : 'Add'}
        secondary={true}
        onClick={this.checkFormValidity}
      />
    );
    if (this.state.loading) {
      button = <Spinning />;
    }

    let error = null;
    if (this.state.error) {
      error = <Notification message={this.state.error} status="critical" className="ss-top-notification" />;
    }
    if (!this.state.selectedGyms) {
      return <Spinning />;
    }

    return (
      <>
        {error}
        {formWarning}
        <Columns justify="between">
          <Box>
            <FormCreator formData={this.state.trainerForm} valueChanged={this.valueChangedHandler} />
          </Box>

          <Box>{this.renderGymSelection(returnGymsByAccess(this.props.locations, this.props.userData))}</Box>
        </Columns>

        {button}
      </>
    );
  }
}

export default withUser(connect(mapStateToProps, mapDispatchToProps)(TrainersAddEditTrainer));
